export var DEPLOY_DATE = new Date('2026-04-16T12:25:21+0000');
